var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2321 5110 c-497 -48 -990 -251 -1376 -565 -114 -92 -294 -274 -384 -387 -229 -287 -417 -675 -495 -1023 -49 -218 -60 -325 -60 -575 0 -250 11 -357 60 -575 79 -355 272 -749 509 -1040 92 -114 274 -294 387 -384 287 -229 675 -417 1023 -495 218 -49 325 -60 575 -60 250 0 357 11 575 60 261 58 603 204 828 353 389 259 688 599 893 1016 125 255 196 484 241 775 24 161 24 539 0 700 -45 291 -116 520 -241 775 -134 272 -283 480 -498 692 -211 209 -404 346 -673 478 -252 124 -486 197 -765 240 -126 19 -468 27 -599 15z m474 -430 c656 -74 1243 -450 1591 -1020 275 -452 369 -998 263 -1530 -113 -567 -480 -1085 -989 -1396 -452 -275 -998 -369 -1530 -263 -567 113 -1085 480 -1396 989 -156 258 -260 562 -294 865 -22 200 -10 457 31 665 113 567 480 1085 989 1396 251 153 562 260 850 293 107 12 379 13 485 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2045 3816 c-27 -13 -58 -32 -67 -42 -29 -33 -58 -107 -58 -149 0 -86 17 -106 508 -597 l467 -468 -467 -467 c-491 -492 -508 -512 -508 -598 0 -42 29 -116 58 -149 26 -30 113 -66 157 -66 87 1 102 13 668 578 296 295 553 557 570 582 29 41 32 52 32 120 0 68 -3 79 -32 120 -17 25 -274 287 -570 582 -566 565 -581 577 -668 578 -22 0 -62 -11 -90 -24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkip);
export default __webpack_public_path__ + "static/media/skip.e90f22f57debc7b5c6030380086e1710.svg";
export { ForwardRef as ReactComponent };